import axios from 'axios';
import { backendUrl } from "../config.js";

// Create axios instance with base URL
const api = axios.create({
  baseURL: backendUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Request password reset
const forgotPassword = async (email) => {
  const response = await api.post('/api/users/forgot-password', { email });
  return response.data;
};

// Reset password with token
const resetPassword = async (token, password, passwordConfirm) => {
  const response = await api.patch(`/api/users/reset-password/${token}`, {
    password,
    passwordConfirm
  });
  return response.data;
};

// Update password (logged in users)
const updatePassword = async (currentPassword, newPassword, newPasswordConfirm) => {
  const response = await api.patch('/api/users/update-password', {
    currentPassword,
    newPassword,
    newPasswordConfirm
  });
  return response.data;
};



// Export all auth-related functions
export {
  forgotPassword,
  resetPassword,
  updatePassword,
  // Export the axios instance in case it's needed elsewhere
  api as axios
};
